import * as React from "react";
import { useLocation } from "react-router";
import { getAppInsightsClient } from "./AppInsightsClient";

/** Emits WebPageView on hash-route changes. */
export function AnalyticsRouteListener() {
  const location = useLocation();

  React.useEffect(() => {
    const route = `${location.pathname}${location.search}${location.hash}`;
    getAppInsightsClient().trackPageView(route || "/");
  }, [location.pathname, location.search, location.hash]);

  return null;
}
